import React, { useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import GoogleIcon from "@mui/icons-material/Google";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

// Function to render custom icons
// const renderCustomIcon = (iconName, size = 24) => {
//   const iconPath = `/assets/images/bookmark-icons/${iconName}.svg`;
//   return (
//     <img
//       src={iconPath}
//       alt={iconName}
//       style={{
//         width: size,
//         height: size,
//         objectFit: "contain",
//       }}
//       onError={(e) => {
//         // Fallback to Material-UI icon if custom icon fails to load
//         console.warn(`Failed to load custom icon: ${iconName}`);
//         e.target.style.display = "none";
//       }}
//     />
//   );
// };

function Courses({
  checkSkill,
}) {
  // Dialog state
  const [aiDialogOpen, setAIDialogOpen] = useState(false);
  const [aiType, setAIType] = useState(""); // "gemini" or "chatgpt"
  const [copyClicked, setCopyClicked] = useState(false);

  // Improved, more actionable prompt
  const promptText = `Give me a list of the best free video tutorials and websites to learn ${checkSkill} from scratch.`;

  const handleAIClick = (type) => {
    setAIType(type);
    setAIDialogOpen(true);
    setCopyClicked(false);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(promptText);
      setCopyClicked(true);
    } catch (e) {
      // fallback if needed
    }
  };

  const handleAIDialogClose = () => {
    setAIDialogOpen(false);
    setCopyClicked(false);
    setAIType("");
  };

  const handleAIRedirect = () => {
    let url = "";
    if (aiType === "gemini") {
      url = "https://gemini.google.com/app";
    } else if (aiType === "chatgpt") {
      url = "https://chat.openai.com/";
    }
    window.open(url, "_blank");
    handleAIDialogClose();
  };    

  return (
    <Box
      id="courses"
      sx={{
        p: { xs: 2, md: 3 },
        // border: "1px solid #000088",
        borderRadius: "39px",
        background: "#F3FBFF",
        height: "100%",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 2,
        }}
      >
        {renderCustomIcon("courses", 40)}
        <Typography
          variant="h6"
          sx={{
            fontFamily: "poppins",
            fontWeight: 700,
            textAlign: "center",
            color: "#000088",
          }}
        >
          Courses For{" "}
          <span style={{ fontWeight: 700 }}>{checkSkill}</span>
        </Typography>
      </Box> */}
      {/* Add YouTube, Google, Gemini, and ChatGPT buttons */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          mt: 2,
        }}
      >
        {/* Unified button style for all course buttons */}
        <Box
          component="a"
          href={`https://www.youtube.com/results?search_query=${encodeURIComponent(
            checkSkill + " tutorial"
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            width: "100%",
            maxWidth: 316,
            minHeight: 40,
            fontFamily: "Poppins",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #FF0000",
            color: "#FF0000",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "12px",
            bgcolor: "transparent",
            gap: 1.5,
            mb: 0,
            transition: "background 0.2s, color 0.2s",
            "&:hover": {
              bgcolor: "#FF0000",
              color: "#fff",
            },
          }}
        >
          <YouTubeIcon sx={{ fontSize: 22, mr: 1 }} />
          YouTube
        </Box>
        <Box
          component="a"
          href={`https://www.google.com/search?q=${encodeURIComponent(
            checkSkill + " tutorial"
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            width: "100%",
            maxWidth: 316,
            minHeight: 40,
            fontFamily: "Poppins",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #4285F4",
            color: "#4285F4",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "12px",
            bgcolor: "transparent",
            gap: 1.5,
            mb: 0,
            transition: "background 0.2s, color 0.2s",
            "&:hover": {
              bgcolor: "#4285F4",
              color: "#fff",
            },
          }}
        >
          <GoogleIcon sx={{ fontSize: 22, mr: 1 }} />
          Google
        </Box>
        <Box
          component="button"
          type="button"
          onClick={() => handleAIClick("gemini")}
          sx={{
            width: "100%",
            maxWidth: 320,
            minHeight: 44,
            fontFamily: "Poppins",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #673AB7",
            color: "#673AB7",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "12px",
            bgcolor: "transparent",
            gap: 1.5,
            mb: 0,
            cursor: "pointer",
            transition: "background 0.2s, color 0.2s",
            "&:hover": {
              bgcolor: "#673AB7",
              color: "#fff",
            },
          }}
        >
          <img
            src="../../assets/images/gemini-logo.png"
            alt="Gemini Logo"
            style={{
              width: 22,
              height: 22,
              marginRight: 8,
              display: "inline-block",
            }}
          />
          Google Gemini
        </Box>
        <Box
          component="button"
          type="button"
          onClick={() => handleAIClick("chatgpt")}
          sx={{
            width: "100%",
            maxWidth: 320,
            minHeight: 44,
            fontFamily: "Poppins",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #00A67E",
            color: "#00A67E",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "12px",
            bgcolor: "transparent",
            gap: 1.5,
            mb: 0,
            cursor: "pointer",
            transition: "background 0.2s, color 0.2s",
            "&:hover": {
              bgcolor: "#00A67E",
              color: "#fff",
            },
          }}
        >
          <img
            src="../../assets/images/chatgpt-btn.png"
            alt="ChatGPT Logo"
            style={{
              width: 22,
              height: 22,
              marginRight: 8,
              display: "inline-block",
            }}
          />
          ChatGPT
        </Box>
      </Box>
      {/* AI Prompt Dialog */}
      <Dialog
        open={aiDialogOpen}
        onClose={handleAIDialogClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            p: 0,
            overflow: "visible",
            minWidth: { xs: "90%", sm: 400 },
            maxWidth: 400,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
          },
        }}
      >
        <Box sx={{ position: "absolute", top: 12, right: 12 }}>
          <Button
            onClick={handleAIDialogClose}
            sx={{
              minWidth: 0,
              p: 0.5,
              borderRadius: "50%",
              bgcolor: "#E5E7EB",
              color: "#1F2A44",
              "&:hover": { bgcolor: "#D1D5DB" },
            }}
          >
            <CloseIcon />
          </Button>
        </Box>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "20px",
            pt: 3,
            pb: 1,
            fontFamily: "Poppins, sans-serif",
            color: "#1F2A44",
          }}
        >
          Jump to {aiType === "gemini" ? "Gemini" : "ChatGPT"}
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", px: 3, pt: 0 }}>
          <Typography
            sx={{
              mb: 2,
              color: "#6B7280",
              fontSize: "14px",
              fontWeight: 400,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            Copy the below starter prompt, then paste it into{" "}
            {aiType === "gemini" ? "Gemini" : "ChatGPT"} to start a
            conversation.
          </Typography>
          <Box
            sx={{
              bgcolor: "#F3F6FA",
              borderRadius: "8px",
              p: 1.5,
              mb: 3,
              fontFamily: "Fira Mono, monospace",
              fontSize: "14px",
              color: "#1F2A44",
              display: "inline-block",
              minWidth: 240,
              maxWidth: "100%",
              textAlign: "left",
              border: "1px solid #E5E7EB",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            }}
          >
            {promptText}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "space-evenly",
            gap: 2,
            pb: 3,
            pt: 0,
            px: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Button
            variant={copyClicked ? "outlined" : "contained"}
            startIcon={copyClicked ? <CheckIcon /> : <ContentCopyIcon />}
            onClick={handleCopy}
            disabled={copyClicked}
            sx={{
              width: { xs: "100%", sm: 150 },
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: 1.5,
              borderRadius: "8px",
              mb: { xs: 1, sm: 0 },
              bgcolor: copyClicked ? "transparent" : "#3B82F6",
              color: copyClicked ? "#3B82F6" : "#fff",
              border: copyClicked ? "1px solid #3B82F6" : "none",
              "&:hover": {
                bgcolor: copyClicked ? "#F0F0F0" : "#2563EB",
              },
            }}
          >
            {copyClicked ? "Copied" : "Copy to clipboard"}
          </Button>
          <Button
            variant="contained"
            onClick={handleAIRedirect}
            disabled={!copyClicked}
            sx={{
              width: { xs: "100%", sm: 150 },
              fontWeight: 500,
              ml: "0px !important",
              fontSize: "14px",
              lineHeight: 1.5,
              borderRadius: "8px",
              bgcolor: !copyClicked ? "#E5E7EB" : "#3B82F6",
              color: !copyClicked ? "#6B7280" : "#fff",
              "&:hover": {
                bgcolor: !copyClicked ? "#E5E7EB" : "#2563EB",
              },
            }}
            startIcon={<OpenInNewIcon />}
          >
            Continue to {aiType === "gemini" ? "Gemini" : "ChatGPT"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Courses;
